import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';
import { Helmet } from "react-helmet";

function Contact() {
  const [activitydatas, setActivityDatas] = useState(null);
  const [contactpage, setContactPage] = useState(null);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch("https://planjourneysglobal.com/admin/api/home_page/banners/contact")
      .then(res => res.json())
      .then(res => setActivityDatas(res.data?.[0] || null))
      .catch(err => console.log(err));
  }, []);

  useEffect(() => {
    fetch("https://planjourneysglobal.com/admin/api/locations/list")
      .then((res) => res.json())
      .then((res) => {
        if (res.status) {
          setLocations(res.data || []);
        }
      })
      .catch((err) => console.log("Location Error:", err));
  }, []);

  useEffect(() => {
    fetch("https://planjourneysglobal.com/admin/api/contact_page")
      .then(res => res.json())
      .then(res => setContactPage(res.data?.[0] || null))
      .catch(err => console.log(err));
  }, []);

  const [successMsg, setSuccessMsg] = useState("");
  const [formData, setFormData] = useState({
    full_name: "",
    email_address: "",
    phone_no: "",
    location_id: "",
    Message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setLoading(true); // Start loading

    fetch("https://planjourneysglobal.com/admin/api/contact_us", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((result) => {
        setLoading(false); // Stop loading
        setSuccessMsg("Thank you! Your message has been submitted.");

        // empty form after submit
        setFormData({
          full_name: "",
          email_address: "",
          phone_no: "",
          location_id: "",
          Message: "",
        });
      })
      .catch((err) => {
        setLoading(false); // Stop loading on error
        console.log("Submit Error:", err);
      });
  };

  return (
    <>
  {contactpage && (
  <Helmet>
    <title>{contactpage.meta_title || "Contact Us"}</title>

    <meta
      name="description"
      content={contactpage.meta_discription || ""}
    />

    {contactpage.meta_keyword && (
      <meta name="keywords" content={contactpage.meta_keyword} />
    )}

    {/* Canonical */}
    {contactpage.slug ? (
      <link
        rel="canonical"
        href={`https://planjourneysglobal.com/${contactpage.slug}`}
      />
    ) : (
      <link rel="canonical" href={window.location.href} />
    )}

    {/* Open Graph */}
    <meta property="og:title" content={contactpage.meta_title || ""} />

    <meta
      property="og:description"
      content={contactpage.meta_discription || ""}
    />

    {contactpage.image_url && (
      <meta property="og:image" content={contactpage.image_url} />
    )}

    {contactpage.slug && (
      <meta
        property="og:url"
        content={`https://planjourneysglobal.com/${contactpage.slug}`}
      />
    )}

    <meta property="og:type" content="website" />

    {/* Twitter */}
    <meta name="twitter:title" content={contactpage.meta_title || ""} />

    <meta
      name="twitter:description"
      content={contactpage.meta_discription || ""}
    />

    {contactpage.image_url && (
      <meta name="twitter:image" content={contactpage.image_url} />
    )}

    <meta name="twitter:card" content="summary_large_image" />
  </Helmet>
)}

      <Header />

      <>
        {/* Start Breadcrumb section */}
        <div
          className="breadcrumb-section"
          style={{
            backgroundImage: activitydatas?.image_url
              ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${activitydatas.image_url})`
              : "none"
          }}
        >
          <div className="container">
            <div className="banner-content">
              <h1>Contact Us{contactpage?.sections?.title}</h1>
            </div>
          </div>
        </div>
        {/* End Breadcrumb section */}

        {activitydatas?.short_discription?.trim() && (
          <div className="container">
            <div
              className="row justify-content-center mb-10 mt-30 wow animate fadeInDown"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <div className="col-lg-6">
                <div className="section-title text-center">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: activitydatas.short_discription
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}


        {/* Contact Page Start*/}
        <div className="contact-page pt-100 mb-100">
          <div className="container">
            {contactpage?.sections?.length > 0 && (
              <div className="row g-xl-4 g-lg-3 g-4 mb-100 justify-content-center">
                {contactpage.sections.map((item, index) => (
                  <div className="col-lg-4 col-md-6" key={index}>
                    <div className="single-contact">
                      {item.image && (
                        <div className="contact-img mb-20">
                          <img
                            src={item.image}
                            alt={item.state_name}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/assets/img/no-image.png";
                            }}
                            width={40}
                          />
                        </div>
                      )}
                      <h4>{item.state_name}</h4>
                      {item.contact_no && <h6>{item.contact_no}</h6>}
                      {item.address && (
                        <p>{item.address}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="contact-form">
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-10">
                  <div className="contact-form-wrap">
                    <div className="section-title text-center mb-60">
                      <h2>Get in Touch!</h2>
                      <p>
                        We’re excited to hear from you! Whether you have a question
                        about our services, want to discuss a new project.
                      </p>
                    </div>
                    <form className="TEST" onSubmit={handleSubmit}>
                      <div className="row g-4 mb-60">

                        <div className="col-md-6">
                          <div className="form-inners">
                            <label>Full Name</label>
                            <input
                              name="full_name"
                              className="form-control"
                              type="text"
                              placeholder="Full Name"
                              value={formData.full_name}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-inners">
                            <label>Email Address</label>
                            <input
                              name="email_address"
                              className="form-control"
                              type="email"
                              placeholder="info@example.com"
                              value={formData.email_address}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-inners">
                            <label>Phone Number</label>
                            <input
                              name="phone_no"
                              className="form-control"
                              type="number"
                              placeholder="Mobile Number"
                              value={formData.phone_no}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-inners">
                            <label>Where are you going?</label>
                            <input type="text"
                            placeholder="Where are you going?"
                              name="destination"
                               className="form-control"
                              value={formData.destination}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-inners">
                            <label>Brief/Message</label>
                            <textarea
                              name="Message"
                              className="form-control"
                              placeholder="Write something about inquiry"
                              value={formData.Message}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                      </div>

                      <button type="submit" className="primary-btn1" disabled={loading}>
                        <span>{loading ? "Submitting..." : "Submit Now"}</span>
                        <span>{loading ? "Submitting..." : "Submit Now"}</span>
                      </button>

                      {successMsg && (
                        <p style={{ color: "green", marginTop: "10px" }}>{successMsg}</p>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            src="assets/img/innerpages/vector/contact-page-vector1.svg"
            alt=""
            className="vector1"
          />
          <img
            src="assets/img/innerpages/vector/contact-page-vector2.svg"
            alt=""
            className="vector2"
          />
          <img
            src="assets/img/innerpages/vector/contact-page-vector3.svg"
            alt=""
            className="vector3"
          />
        </div>
        {/*Contact Page End*/}

      </>

      <Footer />
    </>
  );
}

export default Contact;